module.exports = __webpack_public_path__ + "img/TrueMoney.cd83a177.png";